import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IBranchMastDropdown, ICompanyMastDropdown, ISkillCategoriesDropdown, IUsersDropdown } from "../../models/IDropdown";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { ITeamManagement } from "../../models/TeamManagement";
import { ITeamMast } from "./Table";
import { EmptyTeam } from "./EmptySkillTeam";
import { MultiSelect } from "primereact/multiselect";
import { ITeamSkillMast } from "../../models/ISkillTeamManagement";
import { ILogin, IPermissionProps } from "../../models/Login";
import { JVCheckbox } from "../../shared/JVCheckbox";

const schema = yup.object({
    team_Name: yup.string().required("Team Name is required*").min(3),
    company_ID: yup.number().required("Company is required*").nullable(),
    allocate_Users: yup.number().required("No. Of Allocation is required").typeError("No. Of Allocation is required").nullable(),
    branch_ID: yup.number().when("Company_Name", {
        is: (val: string) => val === "",
        then: yup.number().nullable(),
        otherwise: yup.number().required("Branch is required*").nullable(),
    }),
    teamManagerid: yup.number().when("Branch_Name", val => {
        return (val === "") ?
            yup.number().nullable() :
            yup.number().required("Team Manager is required*").nullable();
    }),
    allocate_For_Same_Branch: yup.boolean().nullable()

});

interface Iprops {
    singleData: ITeamSkillMast,
    teamNameList: ITeamMast[],
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,

}

interface Users {
    branch_ID?: number,
    login_ID?: number,
    user_Name?: string,
}

export const Form = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [diable, setDisable] = useState({ branch: true, teamManage: true });
    const [users, setUsers] = useState<Array<Users>>();
    const [methd, setMethd] = useState("POST");
    const [teamNames, setTeamNames] = useState<Array<string | undefined>>([]);
    const [skillCategories, setSkillCategories] = useState<Array<ISkillCategoriesDropdown>>();
    const [selectSkill, setSelectSkill] = useState<Array<number | undefined>>([]);
    const [recruiterHead, setRecruiterHead] = useState<Array<IUsersDropdown>>();
    const [selectRecruiterHead, setSelectRecruiterHead] = useState<Array<number | undefined>>([]);
    const [isTeam, setIsTeam] = useState(false);

    // let x: string | null = sessionStorage.getItem('auth') || "null";
    // let loginObj = JSON.parse(x);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach((role: { role_ID: number; }) => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<ITeamSkillMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company_ID") {
                if (value.company_ID != 0) {
                    setDisable({ branch: false, teamManage: true });
                    const loadBranches = async () => {
                        const response = await Fetch("Dropdown/branches", "GET", null, `company_id=${value.company_ID}`, null);
                        if (response) {
                            const data: Array<IBranchMastDropdown> = await response.json();
                            setBranches(data);
                        }
                    }
                    loadBranches();
                } else {
                    setDisable({ branch: true, teamManage: true });
                }
            }

            if (name === "branch_ID") {
                if (value.branch_ID != 0) {
                    setDisable({ branch: false, teamManage: false });
                    const loadUsers = async () => {
                        const response = await Fetch("Dropdown/RecuitersByBranch", "GET", null, `branch_ID=${value.branch_ID}`, null);
                        if (response) {
                            const data: Array<Users> = await response.json();
                            setUsers(data);
                        }
                    }
                    loadUsers();
                } else {
                    setDisable({ branch: false, teamManage: true });
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            setCompanies(data);
        }
    }

    useEffect(() => {
        loadCompanies();
    }, []);

    useEffect(() => {
        let list: (string | undefined)[] = props.teamNameList.map(el => el.team_Name);
        setTeamNames(list);
    }, [props.open]);


    useEffect(() => {
        if (props.singleData.branch_ID != 0 && props.singleData.branch_ID != null) {
            setDisable({ branch: false, teamManage: true });
            setMethd("PUT");
            const loadBranches = async () => {
                const response = await Fetch("Dropdown/branches", "GET", null, `company_id=${props.singleData.company_ID}`, null);
                if (response) {
                    const data: Array<IBranchMastDropdown> = await response.json();
                    setBranches(data);
                }
            }
            loadBranches();
        }
        if (props.singleData.teamManagerid != 0 && props.singleData.teamManagerid != null) {
            setMethd("PUT");
            setDisable({ branch: false, teamManage: false });
            const loadUsers = async () => {
                const response = await Fetch("Dropdown/RecuitersByBranch", "GET", null, `branch_ID=${props.singleData.branch_ID}`, null);
                if (response) {
                    const data: Array<Users> = await response.json();
                    setUsers(data);
                }
            }
            loadUsers();
        }
        reset(props.singleData);
    }, [props.singleData]);

    // interface Branches {
    //     branch_ID: number
    // }

    const saveToDB = async (body: ITeamSkillMast) => {
        let data: any;
        if (body.team_ID) {
            data = {
                ...body,
                skillCategories: selectSkill,
                recruiter_Head_ID: selectRecruiterHead

            };
        } else {
            data = {
                team_Name: body.team_Name,
                status: true,
                user_Added_by: loginObj.id,
                createdOn: new Date(),
                teamManagerid: body.teamManagerid,
                company_ID: body.company_ID,
                allocate_Users: body.allocate_Users,
                skillCategories: selectSkill,
                recruiter_Head_ID: selectRecruiterHead,
                team_Status: true,
                allocate_For_Same_Branch:body.allocate_For_Same_Branch
            };
        }
        const method = methd === "POST" ? "POST" : "PUT";
        const message = methd === "POST" ? "Added Successfully" : "Updated Successfully";

        // let teamNameAvail = true;

        // let newTeamName = body.team_Name;

        // for (let i = 0; i < teamNames.length; i++) {
        //     if (newTeamName?.trim().replace(/\s+/g, "").split(" ").join(" ").toLowerCase() === teamNames[i]?.trim().replace(/\s+/g, "").split(" ").join(" ").toLowerCase()) {
        //         teamNameAvail = false;
        //         i = teamNames.length;
        //     }
        // }

        // if (teamNameAvail && method === "POST") {

        //     props.toast.current.show({ severity: 'error', detail: "This Team Name is already exist", life: 3000 });
        // } else {
        if (data.teamManagerid === null || data.teamManagerid === 0) {
            props.toast.current.show({ severity: 'error', detail: "Please Select Team Manager", life: 3000 });
        } else {
            const response = await Fetch("Team_Skill_Mast", method, data, null, props.toast);
            if (response) {
                setSelectSkill([]);
                setSelectRecruiterHead([]);
                onHide();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                props.setReload(!props.reload);
            }
        }
    }

    useEffect(() => {
        if (control._formValues.Company_Name === "" && control._formValues.Branch_Name != "") props.toast.current.show({ severity: 'error', detail: "Select the State First.", life: 3000 });
    }, [control._formValues.Branch_Name]);

    const onHide = () => {
        setMethd("POST");
        props.hideDialog();
        reset(EmptyTeam);
        setDisable({ branch: true, teamManage: true });
        setSelectSkill([]);
        setSelectRecruiterHead([]);
    }

    function onSubmit(data: ITeamSkillMast) {
        if (selectSkill?.length == 0) {
            props.toast.current.show({ severity: 'error', detail: "Please Select a Category", life: 3000 });
        } else {
            console.log(data);
            saveToDB(data);
        }
    }
    const loadSkillCategories = async () => {
        const response = await Fetch("Dropdown/skillsCategories", "GET", null, null, null);
        if (response) {
            const data: Array<ISkillCategoriesDropdown> = await response.json();
            const emptyData = {
                req_CategoryID: 0,
                req_CategoryName: "-- SELECT --",
            };
            // data.unshift(emptyData);
            setSkillCategories(data);
        }
    }

    const loadSelectedSkillCategories = async () => {
        const response = await Fetch("Team_Skill_Mast/getSkillsCategories", "GET", null, `team_id=${props.singleData.team_ID}`, props.toast);
        if (response) {
            const data: ISkillCategoriesDropdown[] = await response.json();
            let categoriesID: (number | undefined)[] = data.map(e => e?.req_CategoryID);
            setSelectSkill(categoriesID);
        }
    }

    const loadSelectedUsers = async () => {
        const response = await Fetch("Team_Skill_Mast/getSkillsRecruiterHeads", "GET", null, `team_id=${props.singleData.team_ID}`, props.toast);
        if (response) {
            const data: IUsersDropdown[] = await response.json();
            let login_ID: (number | undefined)[] = data.map(e => e?.login_ID);
            setSelectRecruiterHead(login_ID);

        }
    }
    const loadUsers = async () => {
        const response = await Fetch("Dropdown/recruiterHeads", "GET", null, null, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            setRecruiterHead(data);
        }
    }
    useEffect(() => {

        if (props.open) {
            loadUsers();
            loadSkillCategories();
            setSelectSkill([]);
            setSelectRecruiterHead([])
            if (props.singleData.team_ID != null) {
                loadSelectedSkillCategories();
                loadSelectedUsers();
            }
        }
    }, [props.open])

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "allocate_For_Same_Branch") {
                if (value.allocate_For_Same_Branch === true) setIsTeam(true);
                else setIsTeam(false);
            }
            
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit  Team Skill" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Team Name" control={control} name="team_Name" error={errors.team_Name?.message} />
                <JVDropdown required label="Company" control={control} name="company_ID" error={errors.company_ID?.message} options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
                <JVDropdown required label="Branch" control={control} name="branch_ID" disabled={diable.branch} error={errors.branch_ID?.message} options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
                <JVDropdown required label="Team Manager" control={control} name="teamManagerid" disabled={diable.teamManage} error={errors.teamManagerid?.message} options={users} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Team Manager" />
                <div style={{ width: '49%' }} >
                    <label className="ml-3" style={{ display: 'block', marginBottom: '8px' }}>Select Skill Category<small className="p-error" >*</small></label>
                    <MultiSelect required value={selectSkill} disabled={(!(_roles.includes(1) || _roles.includes(26) || _roles.includes(13)  || _roles.includes(19)))} onChange={(e) => setSelectSkill(e.value)} options={skillCategories} optionLabel="req_CategoryName" optionValue="req_CategoryID" display="chip" filter placeholder="Select Skill Category" maxSelectedLabels={10} className=" ml-3 mb-3" />
                </div>
                <div className="ml-3 mr-1" style={{ width: '49%' }} >
                    <JVInput required column={1} type="number" label="Allocate User(s)" control={control} name="allocate_Users" error={errors.allocate_Users?.message} />
                </div>
                <div style={{ width: '49%' }} >
                    <label className="ml-3" style={{ display: 'block', marginBottom: '8px' }}>Select Recruiter Head<small className="p-error" ></small></label>
                    <MultiSelect value={selectRecruiterHead} onChange={(e) => setSelectRecruiterHead(e.value)} options={recruiterHead} optionLabel="user_Name" optionValue="login_ID" display="chip" filter placeholder="Select Recruiter Head" maxSelectedLabels={10} className=" ml-3 mb-3" />
                </div>
                <div className="mt-5 mr-2" style={{ width: '60%' }} >
                <JVCheckbox column={4} label="Allocate From Same Branch" control={control} name="allocate_For_Same_Branch" />
                </div>


                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit"></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}